export const editorRoles = [
  {
    role: 'alabama_editor', // BamaOnLine - Alabama
    site: [72],
  },
  {
    role: 'auburn_editor', // Auburn Live - Auburn
    site: [76],
  },
  {
    role: 'notre_dame_editor', // Blue and Gold - Notre Dame
    site: [363],
  },
  {
    role: 'wearesc_editor', // WeAreSC - USC
    site: [79],
  },
  {
    role: 'insidetexas_editor', // InsideTexas - Texas
    site: [73],
  },
  {
    role: 'scoop_duck_editor', // Scoop Duck - Oregon
    site: [75],
  },
  {
    role: 'ksr_editor', // KSR - Kentucky
    site: [24, 395],
  },
  {
    role: 'lettermen_row_editor', // Lettermen Row - Ohio State
    site: [25],
  },
  {
    role: 'clemson_sports_editor', // Clemson Sports - Clemson
    site: [9],
  },
  {
    role: 'dawgshq_editor', // DawgsHQ - Georgia
    site: [74],
  },
  {
    role: 'florida_editor', // GatorsOnline - Florida
    site: [83],
  },
  {
    role: 'lsu_editor', // The Bengal Tiger - LSU
    site: [364],
  },
  {
    role: 'miami_editor', // Cane Sports - Miami
    site: [371],
  },
  {
    role: 'michigan_editor', // The Wolverine - Michigan
    site: [80],
  },
  {
    role: 'nc_state_editor', // The Wolfpacker - NC State
    site: [82],
  },
  {
    role: 'nebraska_editor', // HuskerOnline - Nebraska
    site: [370],
  },

  {
    role: 'ole_miss_editor', // OM Spirit - OleMiss
    site: [362],
  },
  {
    role: 'penn_state_editor', // BWI - Penn State
    site: [81],
  },
  {
    role: 'smu_editor', // On The Pony Express - SMU
    site: [365],
  },
  {
    role: 'south_carolina_editor', // GamecockCentral - South Carolina
    site: [366],
  },
  {
    role: 'texas_am_editor', // Texas AM
    site: [367],
  },
  {
    role: 'fsu_editor', // Warchant - FSU
    site: [372],
  },
  {
    role: 'tennessee_editor', // Volquest - Tennessee
    site: [373],
  },
  {
    role: 'kansas_state_editor', // K-State Online - Kansas State
    site: [374],
  },
  {
    role: 'purdue_editor', // Gold and Black - Purdue
    site: [377],
  },
  {
    role: 'michigan_state_editor', // SpartanMag - Michigan State
    site: [382],
  },
  {
    role: 'iowa_editor', // Hawkeye Report - Iowa
    site: [383],
  },
  {
    role: 'oklahoma_editor', // Sooner Scoop - Oklahoma
    site: [396],
  },
  {
    role: 'mississippi_state_editor', // Maroon and white - Mississippi State
    site: [376],
  },
  {
    role: 'indiana_editor', // TheHoosier - Indiana
    site: [408],
  },
  {
    role: 'softball_america_editor', // Softball - Softball America
    site: [401],
  },
  { role: 'asu_devils_editor', site: [412] },
  { role: 'hawg_beat_editor', site: [415] },
  { role: 'go_black_knights_editor', site: [416] },
  { role: 'eagle_action_editor', site: [417] },
  { role: 'golden_bear_report_editor', site: [418] },
  { role: 'tiger_illustrated_editor', site: [419] },
  { role: 'cu_sports_report_editor', site: [420] },
  { role: 'devils_illustrated_editor', site: [421] },
  { role: 'jackets_online_editor', site: [422] },
  { role: 'orange_and_blue_news_editor', site: [] },
  { role: 'cyclone_report_editor', site: [424] },
  { role: 'jayhawk_slant_editor', site: [425] },
  { role: 'bleed_tech_blue_editor', site: [426] },
  { role: 'cardinal_sports_editor', site: [427] },
  { role: 'terrapin_sports_report_editor', site: [428] },
  { role: 'gophers_nation_editor', site: [429] },
  { role: 'mizzou_today_editor', site: [430] },
  { role: 'the_mid_report_editor', site: [431] },
  { role: 'tar_heel_illustrated_editor', site: [432] },
  { role: 'wildcat_report_editor', site: [433] },
  { role: 'o_state_illustrated_editor', site: [434] },
  { role: 'beavers_edge_editor', site: [435] },
  { role: 'pitt_sports_news_editor', site: [436] },
  { role: 'the_knight_report_editor', site: [437] },
  { role: 'pirate_crew_editor', site: [438] },
  { role: 'bulls_insider_editor', site: [439] },
  { role: 'big_gold_nation_editor', site: [440] },
  { role: 'cardinal_sports_report_editor', site: [] },
  { role: 'owl_scoop_editor', site: [442] },
  { role: 'aggie_yell_editor', site: [443] },
  { role: 'red_raider_sports_editor', site: [444] },
  { role: 'inside_tulsa_sports_editor', site: [445] },
  { role: 'ucf_sports_editor', site: [446] },
  { role: 'bruin_blitz_editor', site: [447] },
  { role: 'the_dore_report_editor', site: [448] },
  { role: 'cavs_corner_editor', site: [449] },
  { role: 'deacons_illustrated_editor', site: [450] },
  { role: 'wv_sports_editor', site: [451] },
  { role: 'badger_blitz_editor', site: [452] },
  { role: 'uga_sports_editor', site: [453] },
  { role: 'cats_illustrated_editor', site: [454] },
  { role: 'maize_blue_review_editor', site: [455] },
  { role: 'spartans_illustrated_editor', site: [456] },
  { role: 'inside_nebraska_editor', site: [457] },
  { role: 'ou_insider_editor', site: [458] },
  { role: 'alabama_varsity_editor', site: [459] },
  { role: 'arizona_varsity_editor', site: [460] },
  { role: 'colorado_prep_report_editor', site: [461] },
  { role: 'fla_varsity_editor', site: [462] },
  { role: 'ga_varsity_editor', site: [463] },
  { role: 'edgy_tim_editor', site: [464] },
  { role: 'hickory_husker_editor', site: [465] },
  { role: 'iowa_preps_editor', site: [466] },
  { role: 'maryland_varsity_editor', site: [467] },
  { role: 'huskerland_preps_editor', site: [468] },
  { role: 'nj_hoops_editor', site: [469] },
  { role: 'nm_preps_editor', site: [470] },
  { role: 'nyc_hoops_editor', site: [471] },
  { role: 'nor_cal_preps_editor', site: [472] },
  { role: 'nc_preps_editor', site: [473] },
  { role: 'ohio_preps_editor', site: [474] },
  { role: 'pa_preps_editor', site: [475] },
  { role: 'tn_varsity_editor', site: [476] },
  { role: 'lone_star_preps_editor', site: [477] },
  { role: 'virginia_preps_editor', site: [478] },
  { role: 'washington_preps_editor', site: [479] },
];
